import React from 'react';
import { DatePicker, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import type { Moment } from 'moment';

const COLLECTION_DATE_FIELD = 'collection_date';
const DATE_FORMAT = 'DD-MM-YYYY';

interface CollectionDateProps {
	fileId: string;
}

function isFutureDate(current: Moment): boolean {
	const result = current.valueOf() >= Date.now();

	return result;
}

export function CollectionDate({ fileId }: Readonly<CollectionDateProps>): JSX.Element {
	return (
		<Form.Item
			name={[fileId, COLLECTION_DATE_FIELD]}
			label={I18n.get('Collection date')}
			labelCol={{ span: 24 }}
			rules={[{ required: true, message: I18n.get('Insert the date of collection') }]}
		>
			<DatePicker format={DATE_FORMAT} disabledDate={isFutureDate} placeholder={I18n.get('Choose the date')} />
		</Form.Item>
	);
}
